import { createStyles, makeStyles } from '@material-ui/core/styles';
import { STYLE } from '../../../../constants';
import { toREM } from '../../../../utils/generalUtils';

export const useStyles = makeStyles(theme =>
  createStyles({
    modalWrapper: {
      maxWidth: '700px !important',
      minWidth: 'auto !important',
      width: '100%',
      '@media (min-width: 600px)': {
        marginLeft: 112,
      },
      '& .MuiPaper-root': {
        maxWidth: '1220px',
        width: '100%',
        minWidth: '72.5%',
      },
      '& .contentContainer': {
        position: 'relative',
        paddingRight: '2.3rem',
        paddingLeft: '2.3rem',
        backgroundColor: STYLE.COLOR.QUINARY_LIGHTER,
        paddingTop: 24,
        paddingBottom: 24,
      },
    },
    cardFont: {
      fontSize: `${toREM(STYLE.FONT.SIZE.PARAGRAPH)}`,
      color: STYLE.COLOR.SECONDARY,
      lineHeight: '26px',
    },
    cardFontAccent: {
      fontWeight: 600,
    },
    messageText: {
      marginTop: 16,
    },
    reportModalTitle: {
      color: STYLE.COLOR.ERROR_ICON,
    },
    modalRoot: {
      zIndex: '10000 !important' as any,
    },
  })
);
